import React from 'react'
import Session from 'components/Session'

export default Component => props => (
  <Session
    render={sessionProps => <Component session={sessionProps} {...props} />}
  />
)



// WEBPACK FOOTER //
// ./src/components/withSession.js